export default __webpack_public_path__ + "static/media/bfc.f3447f2a.png";